import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'

import { italyFiscalCodesManagementActions } from '../italyFiscalCodesManagementSagas'
import { selectItalyFiscalCodesManagement } from '../italyFiscalCodesManagementSelectors'
import { closeDeleteModal } from '../italyFiscalCodesManagementSlice'

const useDeleteModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { deleteTarget, isDeleting } = useSelector(selectItalyFiscalCodesManagement)
  const code = deleteTarget?.code ?? ''

  const cancel = () => {
    if (isDeleting) return
    dispatch(closeDeleteModal())
  }

  const onOpenChange = (open: boolean) => {
    if (!open) cancel()
  }

  const confirm = () => {
    if (deleteTarget === null || isDeleting) return
    dispatch({ type: italyFiscalCodesManagementActions.DELETE, enqueue })
  }

  return {
    isOpen: deleteTarget !== null,
    isDeleting,
    title: t('italyFiscalCodesManagement:delete_modal.title', { code }),
    text: t('italyFiscalCodesManagement:delete_modal.text', { code, name: deleteTarget?.name ?? '' }),
    confirmLabel: t('common:delete'),
    cancelLabel: t('common:cancel'),
    onOpenChange,
    cancel,
    confirm,
  }
}

export default useDeleteModal
